<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><span class="bold">The Murder on the Links</span></h1>
<p class="subtitle">A Hercule Poirot Mystery</p>
<p class="author">Agatha Christie</p>
<p class="author"><img alt="image" src="images/logo3.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?d168b926